var o = Object.defineProperty;
var a = (i, e, t) => e in i ? o(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var r = (i, e, t) => a(i, typeof e != "symbol" ? e + "" : e, t);
import { s as p, H as d } from "./vidstack-D3W_YeLC.js";
import { H as u } from "./vidstack-html-DbliDeJH.js";
class n extends u {
  constructor(t, s) {
    super(t, s);
    r(this, "$$PROVIDER_TYPE", "AUDIO");
    r(this, "airPlay");
    p(() => {
      this.airPlay = new d(this.media, s);
    }, this.scope);
  }
  get type() {
    return "audio";
  }
  setup() {
    super.setup(), this.type === "audio" && this.ctx.notify("provider-setup", this);
  }
  /**
   * The native HTML `<audio>` element.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement}
   */
  get audio() {
    return this.media;
  }
}
export {
  n as AudioProvider
};
